import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useState, useEffect, createElement, useContext } from 'react';
import {
  Switch,
  useParams,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router';
import Cookies from 'js-cookie';

import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import InputField from '@vb/components/build/components/forms/inputs/InputField/InputField';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/ui/app-sidebar';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import AddNewDocumentMenu from '@/components/AddNewDocumentMenu';
import SignDocumentDialog from '@componentsV2/SignDocumentDialog';
import Search from '@/assets/icons/Search';
import AddFolder from '@/assets/icons/AddFolder';
import AddFile from '@/assets/icons/AddFile';
import UploadFolder from '@/assets/icons/UploadFolder';
import { FileUploadContext } from '@/contexts/fileUpload';
import { sGetUnseenNotifications } from '@/store/reducers/notifications';
import AppSupportEndingDialog from '@componentsV2/AppSupportEndingDialog';
import { acSetAppSupportEndingDialogSeen } from '@/store/actions/appVersionData';
import { sGetAppSupportEndingDialogSeen } from '@/store/reducers/appVersionData';
import PropertyDataProvider from '@componentsV2/PropertyDataProvider';

import {
  sGetActiveProperty,
  sGetPropertiesLoaded,
  sGetFetchingProperties,
  sGetFetchingPropertiesError,
  sGetPropertyByBoligmappaNumber,
  sGetAllProperties,
  sGetOwnedProperties,
  sGetSharedPrivatelyProperties,
  sGetDocumentsToSigned,
  sGetDialogToSignDocSeen,
} from '../../../store/reducers/properties';

import { sGetUser } from '../../../store/reducers/auth';

import { sGetAccessRequests } from '../../../store/reducers/accessRequests';

import {
  fetchProperties as apiFetchProperties,
  fetchNotifications as apiFetchNotifications,
  getAccessRequestsData,
  getPropertyFeatures,
  fetchRooms,
  fetchEvents,
} from '../../../api/properties';

import { fetchDocumentsToSigned } from '../../../api/documents';

import {
  acSetNotifications,
  acSetFetchingNotifications,
  acSetFetchingNotificationsError,
} from '../../../store/actions/notifications';
import {
  acSetProperties,
  acSetActiveProperty,
  acSetFetchingProperties,
  acSetFetchingPropertiesError,
  acSetDocumentsToSigned,
  acSetFetchingDocumentsToSigned,
  acSetDialogToSignDocSeen,
} from '../../../store/actions/properties';
import { actionSetAccessRequests } from '../../../store/actions/accessRequests';
import Images from './Images';
import AddRoomDialog from './Rooms/Room/Add';
import AddEventDialog from './Events/Event/Add';
import Room from './Rooms/Room';
import Terms from './More/Terms';
import Share from './More/Share';
import Referral from './Referral';
import Event from './Events/Event';
import Account from './More/Account';
import Consents from './More/Consents';
import AddDocument from './AddDocument';
import ContactUs from './More/ContactUs';
import Chapter from './Documents/Chapter';
import Document from './Documents/Document';
import ExperimentTemplate from './ExperimentTemplate';
import Rights from './PropertyDetails/Rights';
import AddContextMenu from './AddContextMenu';
import routes from '../../../structure/routes';
import PrivateShare from './More/PrivateShare';
import PropertyDetails from './PropertyDetails';
import ChapterOne from './Documents/ChapterOne';
import PropertyEconomy from './PropertyEconomy';
import ProfileDelete from './More/ProfileDelete';
import CreateMDR from './CreateMDR';
import useDesktop from '../../../hooks/useDesktop';
import PropertyCompanies from './PropertyCompanies';
import Route from '../../../components/atomic/Route';
import Hidden from '../../../components/atomic/Hidden';
import Commitments from './PropertyDetails/Commitments';
import useFetchEffect from '../../../hooks/useFetchEffect';
import {
  acClearRooms,
  acSetFetchingRooms,
  acSetFetchingRoomsError,
  acSetRooms,
  acSetShowAddRoom,
} from '../../../store/actions/rooms';
import PropertyLoans from './PropertyEconomy/PropertyLoans';
import PropertySales from './PropertyEconomy/PropertySales';
import {
  acClearEvents,
  acSetEvents,
  acSetFetchingEvents,
  acSetFetchingEventsError,
  acSetShowAddEvent,
} from '../../../store/actions/events';
import { acClearRights } from '../../../store/actions/rights';
import { acClearMarketEvents } from '../../../store/actions/marketEvents';
import {
  isAddButtonEnabled,
  isFullscreenMode,
  isFullScreenPreviewMode,
  locationsPageTitles,
} from './util';
import DownloadPersonalData from './More/DownloadPersonalData';
import ErrorContainer from '../../../components/ErrorContainer';
import { sGetFetchingRooms, sGetRooms } from '../../../store/reducers/rooms';
import { acClearCompanies } from '../../../store/actions/companies';
import {
  acClearDocuments,
  acSetDocumentSearchText,
  acSetIsCreatingDocumentFolder,
} from '../../../store/actions/documents';
import DashboardLayout from '../../../components/layouts/Dashboard';
import { acClearFinancials } from '../../../store/actions/financials';
import PropertyOwnerships from './PropertyEconomy/PropertyOwnerships';
import { isPropertyOwnerNotFoundError } from '../../../utils/requests';
import { acClearCommitments } from '../../../store/actions/commitments';
import { acBYBFClearRooms } from '../../../store/actions/bybfRooms';
import sessionStorage from '../../../utils/sessionStorage';
import { redirectOptions, redirectPath } from '../../../utils/routes';
import useDashboardLinkPrefix from '../../../hooks/useDashboardLinkPrefix';
import { getPropertyAddress, isPropertyOwned } from '../../../utils/properties';
import PropertySalesLaw from './PropertySalesLaw';
import PropertyFinancials from './PropertyFinancials';
import PropertyMarketEvents from './PropertyMarketEvents';
import FindProfessional from './More/FindProfessional';
import CompanyProfile from './CompanyProfile';
import Addons from './More/Addons';
import { acSetUnitFeatures } from '../../../store/actions/unitFeatures';
import AccessRequestDialog from './More/PrivateShare/Details/AccessRequestDialog';
import localStorage from '../../../utils/localStorage';
import { enableSurveyor } from '../../../config';
import PropertyFinancialsHjemla from './PropertyFinancialsHjemla';
import { sGetEvents, sGetFetchingEvents } from '../../../store/reducers/events';
import { sGetUnitFeatures } from '../../../store/reducers/unitFeatures';
import LoyaltyPage from './LoyaltyPage';
import BoligmappaPlusPage from './BoligmappaPlusPage';
import ContractTemplatePage from '../../PersonalAreaRoutes/Dashboard/ContractTemplatePage';
import BoligmappaPlusLoyaltyCompanyPage from './BoligmappaPlusLoyaltyCompanyPage';
import { isNativeEnv } from '../../../utils/nativeBridge';
import PurchasesPage from './PurchasesPage';
import PersonalArea from './PersonalArea';
import MyDocuments from './PersonalArea/MyDocuments';
import useAddNewDocumentMenu from '../../../hooks/useAddNewDocumentMenu';
import BaseDialogForm from '../../../components/forms/BaseDialogForm';
import {
  sGetDocumentSearchText,
  sGetIsCreatingDocumentFolder,
  sGetPropertyFoldersBreadCrumbs,
  sGetPropertySelectedFolderId,
} from '../../../store/reducers/documents';
import styles from './style';
import Plus from '../../../assets/icons/raw/plus';

export const Dashboard = ({
  classes,
  ownedProperties,
  sharedProperties,
  unseenNotifications,
  propertiesLoaded,
  fetchingProperties,
  fetchingPropertiesError,
  getPropertyByBoligmappaNumber,
  accessRequests,
  activeProperty,
  setUnitFeatures,
  setProperties,
  appSupportEndingDialogSeen,
  setAppSupportEndingDialogSeen,
  setNotifications,
  setActiveProperty,
  setFetchingProperties,
  setFetchingNotifications,
  setFetchingPropertiesError,
  setFetchingNotificationsError,
  setAccessRequests,
  clearRooms,
  clearRights,
  clearBYBFRooms,
  clearEvents,
  clearDocuments,
  clearCompanies,
  clearFinancials,
  clearCommtiments,
  clearMarketEvents,
  searchText,
  setSearchText,
  setShowAddRoom,
  setShowAddEvent,
  fetchingRooms,
  rooms,
  documentsToSigned,
  dialogToSignDocSeen,
  setFetchingRooms,
  setRooms,
  setDocumentsToSigned,
  setDialogToSignDocSeen,
  setFetchingDocumentsToSigned,
  setFetchingRoomsError,
  events,
  setEvents,
  fetching,
  setFetching,
  setFetchingEventsError,
  isCreatingDocumentFolder,
  setIsCreatingDocumentFolder,
  selectedPropertyFolderId,
  propertyFoldersBreadCrumbs,
  activeUser,
}) => {
  const history = useHistory();
  const match = useRouteMatch();
  const isDesktop = useDesktop();
  const { pathname } = useLocation();
  const { boligmappaNumber } = useParams();
  const dashboardLinkPrefix = useDashboardLinkPrefix();
  const fullscreenPreviewMode = isFullScreenPreviewMode(pathname, match.url);
  const fullscreenMode = isFullscreenMode(pathname, match.url);
  const showAddButton = isAddButtonEnabled(pathname, match.url) && !isDesktop;
  const compensateBottomNavigationPadding =
    !showAddButton && !fullscreenMode && !isDesktop;
  const [searchVisible, setSearchVisible] = useState(false);
  const [isCollapsedSidebar, setIsCollapsedSidebar] = useState(false);
  const [pageTitle, setPageTitle] = useState('');
  const [
    isAccessRequestDialogSeenStorage,
    setIsAccessRequestDialogSeenStorage,
  ] = useState(localStorage.get('accessRequestsSeen'));
  const isApp = isNativeEnv();
  const onAccessRequestDialogClose = () => {
    localStorage.set('accessRequestsSeen', true);
    setIsAccessRequestDialogSeenStorage(true);
  };

  const [activeSignDialogIndex, setActiveSignDialogIndex] = useState(0);

  const onDialogToSignClose = (el, index) => {
    setActiveSignDialogIndex(
      index + 1 <
        documentsToSigned.filter(
          (doc) => !dialogToSignDocSeen[doc?.boligmappaNumber]
        ).length
        ? index + 1
        : null
    );
    const dialogToSignSeen = Cookies.get('dialogToSignDocSeen');
    const parsedCookie = dialogToSignSeen ? JSON.parse(dialogToSignSeen) : {};
    const cookieValue = {
      ...parsedCookie,
      [el.boligmappaNumber]: true,
    };
    setDialogToSignDocSeen(cookieValue);
    Cookies.set('dialogToSignDocSeen', cookieValue, { expires: 14 });
  };

  const localActiveProperty =
    activeProperty ||
    (ownedProperties?.length > 0 && ownedProperties[0]) ||
    (sharedProperties?.length > 0 && sharedProperties[0]);

  useEffect(() => {
    const titleKeys = Object.keys(locationsPageTitles(activeProperty));
    const selectedPageTitleKey = titleKeys.find((keyword) =>
      pathname.includes(`${dashboardLinkPrefix}/${keyword}`)
    );
    setPageTitle(
      locationsPageTitles(activeProperty)[selectedPageTitleKey] ||
        `Oversikt - ${getPropertyAddress(activeProperty)}`
    );
    const searchPages = ['documents', 'history', 'events', 'rooms'];
    setSearchVisible(
      searchPages.some((pageString) =>
        pathname.includes(`${dashboardLinkPrefix}/${pageString}`)
      )
    );
  }, [pathname, activeProperty]);

  const { onFileUploadClick } = useContext(FileUploadContext);

  const {
    isCreatingName,
    setIsCreatingName,
    newFolderName,
    setNewFolderName,
    isAddingNewDoc,
    setIsAddingNewDoc,
    folderNameErrorMessage,
    isFolderNameError,
    onFolderCreate,
    onCancelCreatingFolder,
  } = useAddNewDocumentMenu({
    currentDocFolderId: selectedPropertyFolderId,
    breadCrumbs: propertyFoldersBreadCrumbs,
    boligmappaNumber,
  });
  const handleDocumentUpload = () => {
    onFileUploadClick({
      query: {
        bulkUploadMode: true,
        source: isDesktop ? 'table' : 'listView',
        newUpload: true,
      },
    });
    setIsAddingNewDoc(false);
  };

  const onFolderUpload = () => {
    onFileUploadClick({
      query: {
        bulkUploadMode: true,
        source: 'table',
        newUpload: true,
        isRoomOrEvent: true,
        webkitdirectory: true,
        parentDirectoryId: selectedPropertyFolderId,
        breadCrumbs: propertyFoldersBreadCrumbs,
        boligmappaNumber,
      },
    });
    setIsAddingNewDoc(false);
  };

  const handleDropdownChange = (value) => {
    if (pathname.includes('documents')) {
      setIsAddingNewDoc(value);
    }
    if (pathname.includes('history')) {
      setShowAddEvent(true);
    }
    if (pathname.includes('rooms')) {
      setShowAddRoom(true);
    }
  };

  const onSubmitFolderCreate = async () => {
    const submitted = await onFolderCreate();
    if (submitted && !history.location.pathname.includes('documents')) {
      history.push(`${dashboardLinkPrefix}/documents`);
    } else {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    setIsCreatingName(isCreatingDocumentFolder);
  }, [isCreatingDocumentFolder]);

  useEffect(() => {
    setIsCreatingDocumentFolder(isCreatingName);
  }, [isCreatingName]);

  const [isBoligmappaPlusUser, setIsBoligmappaPlusUser] = useState(true); // // change this value to false to test

  useEffect(() => {
    setIsBoligmappaPlusUser(activeUser?.isSubscribeToBoligmappaPlus);
  }, [activeUser]);

  useFetchEffect({
    dependencies: [propertiesLoaded],
    apiFetchFunction: apiFetchProperties,
    conditionFunction: ([_propertiesLoaded]) => !_propertiesLoaded,

    onFetchStart: () => setFetchingProperties(true),
    onFetchComplete: () => setFetchingProperties(false),

    onSuccess: (data) => setProperties(data),
    onError: (error) =>
      isPropertyOwnerNotFoundError(error)
        ? history.push('/signup')
        : setFetchingPropertiesError(error),
  });

  useFetchEffect({
    dependencies: [boligmappaNumber],
    apiFetchFunction: () => apiFetchNotifications(boligmappaNumber),

    onFetchStart: () => setFetchingNotifications(true),
    onFetchComplete: () => setFetchingNotifications(false),

    onSuccess: (data) => setNotifications(data.notifications),
    onError: (error) => setFetchingNotificationsError(error),
  });

  useFetchEffect({
    dependencies: [boligmappaNumber],
    conditionFunction: () =>
      getPropertyByBoligmappaNumber(boligmappaNumber)?.owned,
    apiFetchFunction: () => getAccessRequestsData(boligmappaNumber),
    onSuccess: (data) => setAccessRequests(data),
  });

  useFetchEffect({
    dependencies: [boligmappaNumber],
    apiFetchFunction: () => getPropertyFeatures(boligmappaNumber),

    onFetchStart: () =>
      setUnitFeatures({ unitFeatures: { fetching: true, loaded: false } }),

    onSuccess: (data) => {
      setUnitFeatures({
        unitFeatures: { ...data, fetching: false, loaded: true },
      });
    },
    onError: () =>
      setUnitFeatures({ unitFeatures: { fetching: false, loaded: false } }),
  });

  useFetchEffect({
    setFetchingFunction: setFetchingDocumentsToSigned,
    onSuccess: (data) => setDocumentsToSigned(data?.documents),
    dependencies: [boligmappaNumber],
    conditionFunction: () => !documentsToSigned,
    apiFetchFunction: () => fetchDocumentsToSigned(),
  });

  useFetchEffect({
    setFetchingFunction: setFetchingRooms,
    onSuccess: (data) => setRooms(data),
    onError: (error) => setFetchingRoomsError(error),
    conditionFunction: () => !rooms && !fetchingRooms,
    apiFetchFunction: () => fetchRooms(boligmappaNumber),
  });

  useFetchEffect({
    setFetchingFunction: setFetching,
    onSuccess: (data) => setEvents(data),
    conditionFunction: () => !events && !fetching,
    onError: (error) => setFetchingEventsError(error),
    apiFetchFunction: () => fetchEvents(boligmappaNumber),
  });

  const redirectToSpecific = (currentProperty) => {
    const redirectPathValue = sessionStorage.get(redirectPath);
    if (redirectPathValue) {
      const isPropertyOwnedStaus = isPropertyOwned(currentProperty);
      let redirectUrl = null;
      let authorizedForRedirect = true;
      switch (redirectPathValue) {
        case redirectOptions.privateSharing:
          redirectUrl = `${dashboardLinkPrefix}/more/private-share`;
          authorizedForRedirect = isPropertyOwnedStaus;
          break;
        case redirectOptions.publicSharing:
          redirectUrl = `${dashboardLinkPrefix}/more/share`;
          authorizedForRedirect = isPropertyOwnedStaus;
          break;
        case redirectOptions.home:
          redirectUrl = `${dashboardLinkPrefix}/home`;
          break;
        case redirectOptions.companies:
          redirectUrl = `${dashboardLinkPrefix}/companies`;
          break;
        case redirectOptions.profile:
          redirectUrl = `${dashboardLinkPrefix}/more/account`;
          break;
        case redirectOptions.financials:
          redirectUrl = `${dashboardLinkPrefix}/financials`;
          break;
        case redirectOptions.findProfessional:
          redirectUrl = `${dashboardLinkPrefix}/more/find-professional`;
          break;
        case redirectOptions.otovo:
          redirectUrl = `${dashboardLinkPrefix}/addon/otovo`;
          break;
        case redirectOptions.boligmappaPlus:
          redirectUrl = `${dashboardLinkPrefix}/boligmappa-plus`;
          break;
        case redirectOptions.myPurchases:
          redirectUrl = `${dashboardLinkPrefix}/my-purchases`;
          break;
        case redirectOptions.documents:
          redirectUrl = `${dashboardLinkPrefix}/documents`;
          break;
        case redirectOptions.vendors:
          redirectUrl = `${dashboardLinkPrefix}/vendors`;
          break;
        case redirectOptions.sparebank1sorostnorge:
          redirectUrl = `${dashboardLinkPrefix}/vendors/company/sparebank-1-sorost-norge`;
          break;
        case redirectOptions.personaldocuments:
          redirectUrl = `/personal-area/dashboard/documents`;
          break;
        case redirectOptions.krogsveen:
          redirectUrl = `${dashboardLinkPrefix}/vendors/company/krogsveen`;
          break;
        case redirectOptions.flisekompaniet:
          redirectUrl = `${dashboardLinkPrefix}/vendors/company/flisekompaniet`;
          break;
        case redirectOptions.ifforsikring:
          redirectUrl = `${dashboardLinkPrefix}/vendors/company/if-forsikring`;
          break;
        case redirectOptions.verisure:
          redirectUrl = `${dashboardLinkPrefix}/vendors/company/verisure`;
          break;
        case redirectOptions.sparebank1GratisPluss:
          redirectUrl = `${dashboardLinkPrefix}/vendors/company/sparebank-1-gratis-pluss`;
          break;
        case redirectOptions.homely:
          redirectUrl = `${dashboardLinkPrefix}/vendors/company/homely`;
          break;
        case redirectOptions.privateShare:
          redirectUrl = `${dashboardLinkPrefix}/more/private-share`;
          break;
        default:
          break;
      }
      if (redirectUrl && authorizedForRedirect) {
        sessionStorage.remove(redirectPath);
        history.push(redirectUrl);
      }
    }
  };

  useEffect(() => {
    const newActiveProperty = getPropertyByBoligmappaNumber(boligmappaNumber);
    if (propertiesLoaded && newActiveProperty) {
      setActiveProperty(newActiveProperty);
      redirectToSpecific(newActiveProperty);
      localStorage.set('accessRequestsSeen', false);
      setIsAccessRequestDialogSeenStorage(false);
    }
    clearRooms();
    clearEvents();
    clearRights();
    clearBYBFRooms();
    clearDocuments();
    clearCompanies();
    clearFinancials();
    clearCommtiments();
    clearMarketEvents();
  }, [boligmappaNumber]);

  useEffect(() => {
    const newActiveProperty = getPropertyByBoligmappaNumber(boligmappaNumber);
    if (propertiesLoaded && newActiveProperty) {
      setActiveProperty(newActiveProperty);
      redirectToSpecific(newActiveProperty);
    }
  }, [propertiesLoaded]);

  useEffect(() => {
    setIsCollapsedSidebar(fullscreenPreviewMode);
  }, [fullscreenPreviewMode]);

  if (fetchingPropertiesError) {
    return <ErrorContainer errorResponse={fetchingPropertiesError} />;
  }

  return (
    <PropertyDataProvider boligmappaNumber={boligmappaNumber}>
      <SidebarProvider open={!isCollapsedSidebar}>
        {isDesktop && (
          <AppSidebar
            ownedProperties={ownedProperties}
            sharedProperties={sharedProperties}
            activeProperty={localActiveProperty}
            unseenNotifications={unseenNotifications}
            activeUser={activeUser}
            documentsToSigned={documentsToSigned}
          />
        )}
        {isDesktop && !fullscreenPreviewMode && (
          <div className="fixed flex justify-end pl-2 pr-2 font-circular bg-sidebar-primary-foreground w-full h-[50px] right-0 z-[99] border-b border-sidebar-border group-data-[collapsible=offcanvas]:w-0">
            <div
              className={`grid grid-cols-3 gap-4 duration-200 items-center ${
                isCollapsedSidebar ? 'w-full' : 'w-[calc(100%-16rem)]'
              }`}
            >
              <div className="flex items-center">
                <SidebarTrigger
                  onClick={() => setIsCollapsedSidebar(!isCollapsedSidebar)}
                />
                <p className="text-xs font-semibold">{pageTitle}</p>
              </div>
              {searchVisible && (
                <>
                  <div className={clsx([classes.searchWrapper, 'max-w-sm'])}>
                    <Search className={classes.searchIcon} />
                    <Input
                      className="h-8 pl-8 shadow-none"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder={`Søk etter ${pageTitle.toLowerCase()}`}
                    />
                  </div>
                  <DropdownMenu
                    modal={false}
                    open={isAddingNewDoc}
                    onOpenChange={handleDropdownChange}
                  >
                    <DropdownMenuTrigger asChild>
                      <Button className="max-w-24 h-8 justify-self-end">
                        <Plus /> Legg til
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                      className="w-[100px] min-w-56 rounded-lg"
                      align="end"
                      sideOffset={4}
                    >
                      <AddNewDocumentMenu
                        isCreatingName={isCreatingName}
                        setIsCreatingName={setIsCreatingName}
                        newFolderName={newFolderName}
                        setNewFolderName={setNewFolderName}
                        isFolderNameError={isFolderNameError}
                        folderNameErrorMessage={folderNameErrorMessage}
                        onCancelCreatingFolder={onCancelCreatingFolder}
                        onFolderCreate={onFolderCreate}
                      >
                        <AddFolder />
                        <p>Ny mappe</p>
                      </AddNewDocumentMenu>
                      <DropdownMenuItem
                        onClick={handleDocumentUpload}
                        className="cursor-pointer"
                      >
                        <AddFile />
                        <p>Last opp fil</p>
                      </DropdownMenuItem>
                      <DropdownMenuItem
                        onClick={onFolderUpload}
                        className="cursor-pointer"
                      >
                        <UploadFolder />
                        <p>Last opp mappe</p>
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </>
              )}
            </div>
          </div>
        )}
        <DashboardLayout
          documentsToSigned={documentsToSigned}
          allProperties={[
            ...(ownedProperties || []),
            ...(sharedProperties || []),
          ]}
          ownedProperties={ownedProperties}
          activeProperty={activeProperty}
          addButtonPaddingEnabled={showAddButton}
          mobileNavbarPaddingEnabled={compensateBottomNavigationPadding}
          isFullscreenPreviewMode={fullscreenPreviewMode}
          backgroundContentContainer="#FAFAFA"
          className={
            !isDesktop || isCollapsedSidebar ? 'w-full' : 'w-[calc(100%-16rem)]'
          }
        >
          {activeProperty &&
            enableSurveyor === 'true' &&
            activeProperty.owned &&
            !isAccessRequestDialogSeenStorage &&
            accessRequests.find((el) => el.status.status === 'Pending') && (
              <AccessRequestDialog
                accessRequestDialog={!isAccessRequestDialogSeenStorage}
                setAccessRequestDialog={onAccessRequestDialogClose}
                accessRequests={accessRequests}
                dashboardLinkPrefix={dashboardLinkPrefix}
              />
            )}
          {routes.map(({ path, component, mobileOnly, hasSubRoutes }) => (
            <Route
              key={`route-${path}`}
              exact={!hasSubRoutes}
              mobileOnly={mobileOnly}
              path={`/dashboard/:boligmappaNumber/${path}`}
              render={(routeProps) =>
                createElement(component, {
                  boligmappaNumber,
                  fetchingProperties,
                  fetchingPropertiesError,
                  ...routeProps,
                })
              }
            />
          ))}

          <Switch>
            <Route
              component={ChapterOne}
              path="/dashboard/:boligmappaNumber/chapters/1"
            />
            <Route
              component={Chapter}
              path="/dashboard/:boligmappaNumber/chapters/:chapterId"
            />
          </Switch>

          <Route
            component={Images}
            path="/dashboard/:boligmappaNumber/images"
          />
          <Route
            exact
            component={PropertyEconomy}
            path="/dashboard/:boligmappaNumber/economy"
          />
          <Route
            exact
            component={PropertyCompanies}
            path="/dashboard/:boligmappaNumber/companies"
          />
          <Route
            component={PropertyLoans}
            path="/dashboard/:boligmappaNumber/economy/loans"
          />
          <Route
            component={PropertyOwnerships}
            path="/dashboard/:boligmappaNumber/economy/ownerships"
          />
          <Route
            component={PropertySales}
            path="/dashboard/:boligmappaNumber/economy/sales"
          />
          <Route
            exact
            component={PropertyDetails}
            path="/dashboard/:boligmappaNumber/details"
          />
          <Route
            component={Commitments}
            path="/dashboard/:boligmappaNumber/details/commitments"
          />
          <Route
            component={Rights}
            path="/dashboard/:boligmappaNumber/details/rights"
          />
          <Route
            component={Event}
            path="/dashboard/:boligmappaNumber/events/:eventId"
          />
          <Route
            component={Document}
            path="/dashboard/:boligmappaNumber/documents/:documentId"
          />
          <Route
            component={ExperimentTemplate}
            path="/dashboard/:boligmappaNumber/addon/:experimentSlug"
          />
          <Route
            component={CompanyProfile}
            path="/dashboard/:boligmappaNumber/company/:companyId"
          />
          <Route
            component={Room}
            path="/dashboard/:boligmappaNumber/rooms/:roomId"
          />
          <Route
            exact
            component={AddDocument}
            path="/dashboard/:boligmappaNumber/add-document"
          />
          <Route
            exact
            component={Referral}
            path="/dashboard/:boligmappaNumber/referral"
          />
          <Route
            exact
            component={PropertySalesLaw}
            path="/dashboard/:boligmappaNumber/sales-law"
          />
          <Route
            exact
            component={PropertyFinancials}
            path="/dashboard/:boligmappaNumber/financials"
          />
          <Route
            exact
            component={PropertyFinancialsHjemla}
            path="/dashboard/:boligmappaNumber/financials/hjemla"
          />
          <Route
            component={PropertyMarketEvents}
            path="/dashboard/:boligmappaNumber/market-events"
          />

          {/* More section routes */}
          <Route
            component={ProfileDelete}
            path="/dashboard/:boligmappaNumber/more/profile-delete"
          />
          <Route
            component={Terms}
            path="/dashboard/:boligmappaNumber/more/terms"
          />
          <Route
            component={Consents}
            path="/dashboard/:boligmappaNumber/more/consents"
          />
          <Route
            component={DownloadPersonalData}
            path="/dashboard/:boligmappaNumber/more/download-personal-data"
          />
          <Route
            component={Account}
            path="/dashboard/:boligmappaNumber/more/account"
          />
          <Route
            component={ContactUs}
            path="/dashboard/:boligmappaNumber/more/contact"
          />
          <Route
            component={Share}
            path="/dashboard/:boligmappaNumber/more/share"
          />
          <Route
            exact
            component={PrivateShare}
            path="/dashboard/:boligmappaNumber/more/private-share"
          />
          <Route
            exact
            component={FindProfessional}
            path="/dashboard/:boligmappaNumber/more/find-professional"
          />
          <Route
            exact
            component={Addons}
            path="/dashboard/:boligmappaNumber/more/addons"
          />
          <Route
            component={CreateMDR}
            path="/dashboard/:boligmappaNumber/create-mdr"
          />
          <Route
            exact
            component={PurchasesPage}
            path="/dashboard/:boligmappaNumber/my-purchases"
          />
          <Route
            exact
            component={LoyaltyPage}
            path="/dashboard/:boligmappaNumber/vendors"
          />
          <Route
            exact
            component={BoligmappaPlusLoyaltyCompanyPage}
            path="/dashboard/:boligmappaNumber/vendors/company/:companyCode"
          />
          {!isApp && (
            <>
              <Route
                exact
                component={BoligmappaPlusPage}
                path="/dashboard/:boligmappaNumber/boligmappa-plus"
              />
              <Route
                component={ContractTemplatePage}
                path="/dashboard/:boligmappaNumber/boligmappa-plus/contract-templates"
              />
            </>
          )}
          <Route
            exact
            component={PersonalArea}
            path="/dashboard/:boligmappaNumber/personal-area"
          />
          <Route
            exact
            component={MyDocuments}
            path="/dashboard/:boligmappaNumber/my-documents"
          />

          {/* Mobile only */}
          {!fullscreenPreviewMode && localActiveProperty?.boligmappaNumber && (
            <Hidden mdUp>
              {showAddButton && (
                <AddContextMenu
                  isBoligmappaPlusUser={isBoligmappaPlusUser}
                  onMobileFolderCreate={() => setIsCreatingDocumentFolder(true)}
                />
              )}
            </Hidden>
          )}

          {isApp && !appSupportEndingDialogSeen && (
            <AppSupportEndingDialog
              setAppSupportEndingDialogSeen={setAppSupportEndingDialogSeen}
            />
          )}

          {documentsToSigned?.length > 0 &&
            documentsToSigned
              .filter((doc) => !dialogToSignDocSeen[doc?.boligmappaNumber])
              .map((el, index) => (
                <SignDocumentDialog
                  key={el?.boligmappaNumber}
                  index={index}
                  open={activeSignDialogIndex === index}
                  onOpenChange={(open) => {
                    if (!open) {
                      onDialogToSignClose(el, index);
                    }
                  }}
                  onClose={() =>
                    setActiveSignDialogIndex(activeSignDialogIndex + 1)
                  }
                  docAvailableToSign={el}
                  property={
                    ownedProperties &&
                    sharedProperties &&
                    [...ownedProperties, ...sharedProperties].find(
                      (prop) => prop.boligmappaNumber === el?.boligmappaNumber
                    )
                  }
                />
              ))}
          <AddRoomDialog />
          <AddEventDialog />
          {!isDesktop && (
            <BaseDialogForm
              open={isCreatingName}
              header="Ny mappe"
              onSubmit={onSubmitFolderCreate}
              onClose={onCancelCreatingFolder}
            >
              <div className={classes.mobileCreateFolderContent}>
                <InputField
                  type="text"
                  label="Opprett mappe:"
                  value={newFolderName}
                  placeholder="Skriv inn mappenavn"
                  onChange={(event) => setNewFolderName(event.target.value)}
                />
                {isFolderNameError && (
                  <p className={classes.errorMessage}>
                    {folderNameErrorMessage}
                  </p>
                )}
              </div>
            </BaseDialogForm>
          )}
        </DashboardLayout>
      </SidebarProvider>
    </PropertyDataProvider>
  );
};

Dashboard.defaultProps = {};

Dashboard.propTypes = {
  getPropertyByBoligmappaNumber: PropTypes.func.isRequired,
  clearRooms: PropTypes.func.isRequired,
  clearEvents: PropTypes.func.isRequired,
  clearCompanies: PropTypes.func.isRequired,
  clearDocuments: PropTypes.func.isRequired,
  clearFinancials: PropTypes.func.isRequired,
  clearCommtiments: PropTypes.func.isRequired,
  clearRights: PropTypes.func.isRequired,
  clearMarketEvents: PropTypes.func.isRequired,
  clearBYBFRooms: PropTypes.func.isRequired,
  setProperties: PropTypes.func.isRequired,
  setActiveProperty: PropTypes.func.isRequired,
  setNotifications: PropTypes.func.isRequired,
  setAccessRequests: PropTypes.func.isRequired,
  setFetchingProperties: PropTypes.func.isRequired,
  setFetchingPropertiesError: PropTypes.func.isRequired,
  setFetchingNotifications: PropTypes.func.isRequired,
  setFetchingNotificationsError: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  properties: sGetAllProperties(state),
  appSupportEndingDialogSeen: sGetAppSupportEndingDialogSeen(state),
  accessRequests: sGetAccessRequests(state),
  fetchingRooms: sGetFetchingRooms(state),
  activeProperty: sGetActiveProperty(state),
  ownedProperties: sGetOwnedProperties(state),
  sharedProperties: sGetSharedPrivatelyProperties(state),
  unseenNotifications: sGetUnseenNotifications(state),
  propertiesLoaded: sGetPropertiesLoaded(state),
  fetchingProperties: sGetFetchingProperties(state),
  getPropertyByBoligmappaNumber: (boligmappaNumber) =>
    sGetPropertyByBoligmappaNumber(state, boligmappaNumber),
  fetchingPropertiesError: sGetFetchingPropertiesError(state),
  rooms: sGetRooms(state),
  documentsToSigned: sGetDocumentsToSigned(state),
  dialogToSignDocSeen: sGetDialogToSignDocSeen(state),
  unitFeatures: sGetUnitFeatures(state),
  events: sGetEvents(state),
  fetching: sGetFetchingEvents(state),
  activeUser: sGetUser(state),
  searchText: sGetDocumentSearchText(state),
  isCreatingDocumentFolder: sGetIsCreatingDocumentFolder(state),
  selectedPropertyFolderId: sGetPropertySelectedFolderId(state),
  propertyFoldersBreadCrumbs: sGetPropertyFoldersBreadCrumbs(state),
});

const mapDispatchToProps = (dispatch) => ({
  clearRooms: () => dispatch(acClearRooms()),
  clearEvents: () => dispatch(acClearEvents()),
  clearRights: () => dispatch(acClearRights()),
  clearBYBFRooms: () => dispatch(acBYBFClearRooms()),
  clearCompanies: () => dispatch(acClearCompanies()),
  clearDocuments: () => dispatch(acClearDocuments()),
  clearFinancials: () => dispatch(acClearFinancials()),
  clearCommtiments: () => dispatch(acClearCommitments()),
  clearMarketEvents: () => dispatch(acClearMarketEvents()),
  setSearchText: (searchText) => dispatch(acSetDocumentSearchText(searchText)),
  setShowAddRoom: (payload) => dispatch(acSetShowAddRoom(payload)),
  setShowAddEvent: (payload) => dispatch(acSetShowAddEvent(payload)),
  setProperties: (properties) => dispatch(acSetProperties(properties)),
  setAppSupportEndingDialogSeen: (value) =>
    dispatch(acSetAppSupportEndingDialogSeen(value)),
  setActiveProperty: (property) => dispatch(acSetActiveProperty(property)),
  setNotifications: (notifications) =>
    dispatch(acSetNotifications(notifications)),
  setFetchingProperties: (fetching) =>
    dispatch(acSetFetchingProperties(fetching)),
  setFetchingPropertiesError: (error) =>
    dispatch(acSetFetchingPropertiesError(error)),
  setFetchingNotifications: (fetching) =>
    dispatch(acSetFetchingNotifications(fetching)),
  setFetchingNotificationsError: (error) =>
    dispatch(acSetFetchingNotificationsError(error)),
  setAccessRequests: (accessRequests) =>
    dispatch(actionSetAccessRequests(accessRequests)),
  setUnitFeatures: (unitFeatures) => dispatch(acSetUnitFeatures(unitFeatures)),
  setRooms: (rooms) => dispatch(acSetRooms(rooms)),
  setDocumentsToSigned: (data) => dispatch(acSetDocumentsToSigned(data)),
  setDialogToSignDocSeen: (data) => dispatch(acSetDialogToSignDocSeen(data)),
  setFetchingDocumentsToSigned: (data) =>
    dispatch(acSetFetchingDocumentsToSigned(data)),
  setFetchingRooms: (fetchingRooms) =>
    dispatch(acSetFetchingRooms(fetchingRooms)),
  setFetchingRoomsError: (fetchingRoomsError) =>
    dispatch(acSetFetchingRoomsError(fetchingRoomsError)),
  setEvents: (events) => dispatch(acSetEvents(events)),
  setFetching: (fetching) => dispatch(acSetFetchingEvents(fetching)),
  setFetchingEventsError: (fetchingEventsError) =>
    dispatch(acSetFetchingEventsError(fetchingEventsError)),
  setIsCreatingDocumentFolder: (isCreatingDocumentFolder) =>
    dispatch(acSetIsCreatingDocumentFolder(isCreatingDocumentFolder)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Dashboard));
